import { useState } from "react";
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import { useStyles } from './styles';

import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import { useHistory } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
function BottomBar() {
  const { themeColor } = useTheme();
  const classes = useStyles(themeColor);
  const [value, setValue] = useState(0);
  let history = useHistory();

  function handleChangePage(path) {
    if (path === history.location.pathname) {
      return
    }
    history.push(path);
  }

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.container}
    >
      <BottomNavigationAction 
        label="Início" 
        icon={<HomeIcon />}
        onClick={() => handleChangePage('/home')}
      />
      <BottomNavigationAction 
        label="Pesquisar" 
        icon={<SearchIcon />} 
        onClick={() => handleChangePage('/pesquisar')}
      />
    </BottomNavigation>
  );
}

export default BottomBar;